import * as React from 'react';

export default class CheckIcon extends React.Component {
  render() {
    let color = this.props.color || '#8cb4d2';

    return (
      <svg className={this.props.svgClass} viewBox="0 0 20 20">
        <g fill={color} fillRule="evenodd">
          <path d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0 2C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10Z" />
          <path d="M13.697 7.39a1 1 0 1 1 1.356 1.47s-5.143 4.635-5.162 4.656a1 1 0 0 1-1.413.067l-2.9-2.637a1 1 0 0 1 1.345-1.48l2.28 2.073 4.494-4.149Z" />
        </g>
      </svg>
    );
  }
}
